import { z } from "zod";

export const ShippingTestMethodDefinitionDtoSchema = z.object({
  id: z.string().uuid().optional(),
  deliveryProfileId: z.string(),
  deliveryLocationGroupId: z.string(),
  deliveryZoneId: z.string(),
  methodDefinitionId: z.string().nullish(),
});

export type ShippingTestMethodDefinitionDto = z.infer<
  typeof ShippingTestMethodDefinitionDtoSchema
>;
